import { useTimezone } from '@app/core/hooks/useTimezone';
import { ReportView } from '@app/core/reports/components/ReportView';
import { normalizeLowerthirdByDateResponse } from '@app/modules/audit/modules/global-audit/helpers/normalize-lowerthird-by-date-response';
import { pntSegmentsControllerGetLowerthirdByDate } from '@mi-front/api-v2';
import { DateTimeStr, toDateTimeStr } from '@mi-front/core';
import moment from 'moment';
import { LowerthirdReport, StationLowerthirdType } from '../../types';
import { LowerthirdForm } from './components/form/filters';
import { LowerthirdResult } from './components/result/LowerthirdResult';

/**
 * Global lowerthird report view; fetches via api-v2 PNT lowerthird endpoint.
 */
export function LowerthirdView() {
  const tz = useTimezone();

  return (
    <ReportView<LowerthirdReport>
      defaultValues={{
        station: { slug: '' },
        from: toDateTimeStr(moment().tz(tz).startOf('day').toISOString()),
        to: toDateTimeStr(moment().tz(tz).endOf('day').toISOString()),
        pageSize: 50,
        pageIndex: 0,
      }}
      download={false}
      queryParamsTransform={{}}
      reportFn={async (values: {
        station: StationLowerthirdType;
        from: DateTimeStr;
        to: DateTimeStr;
      }) => {
        if (!values.station.slug) {
          return [];
        }

        const data = await pntSegmentsControllerGetLowerthirdByDate(values.station.slug, {
          from: values.from,
          to: values.to,
        });

        return normalizeLowerthirdByDateResponse(data);
      }}
      Form={LowerthirdForm}
      Result={LowerthirdResult}
    />
  );
}
